"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckboxWrapper = exports.CatalogOrderButton = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const util_theme_sxc_1 = require("@hotelplan/util.theme.sxc");
const core_fusion_bs_button_with_icon_1 = require("@hotelplan/core.fusion.bs-button-with-icon");
exports.CatalogOrderButton = (0, styled_components_1.default)(core_fusion_bs_button_with_icon_1.BsButtonWithIcon).attrs({
    'data-id': 'catalogOrder',
})(({ theme }) => theme.buttons.iconBtn);
exports.CheckboxWrapper = styled_components_1.default.div((0, util_theme_sxc_1.sx2CssThemeFn)({
    display: 'inline-block',
    '.label': {
        color: 'textGray',
        pl: 0,
        pt: 3,
        mb: 0,
        cursor: 'pointer',
    },
    input: {
        fontSize: [null, 3],
    },
}));
//# sourceMappingURL=fdr-catalogs-order-control.styles.js.map